// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"d05a6795","264":"dbb012e6","290":"5c1e10c3","358":"deefa90f","420":"ffa2973a","571":"82c7d47f","672":"971f6681"}[chunkId] + ".chunk.js";
};